import { SessionTimedOutScreen } from "@/blocks/SessionTimedOutScreen";

export default function SessionExpired() {
  return <SessionTimedOutScreen />;
}
